export default {
      id: "notification-small-usage",
      viewBox: "0 0 17 18",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#notification-small",
      toString: function () {
        return this.url;
      }
    }